import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {ReplaceWorkoutExerciseResult} from '../../domain/workout';
import type {ReplaceWorkoutExerciseInput, WorkoutRepository} from '../ports/workout.repository';

export class ReplaceWorkoutExercise implements UseCase<
  [ReplaceWorkoutExerciseInput],
  ReplaceWorkoutExerciseResult
> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: ReplaceWorkoutExerciseInput,
  ): Promise<Result<ReplaceWorkoutExerciseResult, WorkoutError>> {
    return this.repository.replaceExercise(input);
  }
}
